import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './services/GlobalVariables'
import router from './router'
import store from './store'
import './assets/fonts/icons.js'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

Vue.component('v-select',vSelect)
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
